export default "__VITE_ASSET__DoUN0GcC__"